import { MessageCircle } from "lucide-react";
import { useActiveSeller } from "@/hooks/useActiveSeller";

const FloatingWhatsApp = () => {
  const { seller, whatsapp } = useActiveSeller();
  const greet = seller
    ? `Hola ${seller.name}! Quería hacerte una consulta.`
    : "Hola! Quería hacer una consulta.";
  const url = `https://wa.me/${whatsapp}?text=${encodeURIComponent(greet)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-xl hover:shadow-2xl transition-all hover:scale-110 active:scale-95 flex items-center gap-2 group"
      data-testid="floating-whatsapp-btn"
      aria-label={seller ? `Contactar a ${seller.name} por WhatsApp` : "Contactar por WhatsApp"}
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden md:inline-block max-w-0 group-hover:max-w-xs overflow-hidden whitespace-nowrap transition-all duration-500 font-semibold">
        {seller ? `Chatear con ${seller.name.split(" ")[0]}` : "Chatear con nosotros"}
      </span>
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-ping" />
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full" />
    </a>
  );
};

export default FloatingWhatsApp;
